import { type FC } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useParams } from "react-router";

import { toSafeInt } from "widgets/utils";

import { useURLViewID } from "../../app-utils/hooks/useUrl.js";
import { type BlastJob, type JobResult, type View } from "../../graphql.js";
import { type IAppState } from "../../redux/reducer.js";
import { BlastResultGenomeView } from "./BlastResultGenomeView.js";
import { BlastResultHitSummaryView } from "./BlastResultHitSummaryView.js";

interface IBlastResultHitDetailsViewProps {
  job: BlastJob;
  queryId: number;
  isLoading: boolean;
  jobResult?: JobResult;
}

const BlastResultHitDetailsView: FC<IBlastResultHitDetailsViewProps> = (props) => {
  const { jobId } = useParams<"jobId">();
  const viewId = useURLViewID();
  const savedView = useSelector<IAppState, View>((state) => state.savedView.view);
  const { queryId, hitNum } = useParams<"queryId" | "hitNum">();

  return (
    <Routes>
      <Route
        index
        element={<Navigate to={`/job/${jobId}/results/${queryId}/hitdetails/${hitNum}/summary`} replace />}
      ></Route>
      <Route
        path={"summary/*"}
        element={
          <BlastResultHitSummaryView
            job={props.job}
            isLoading={props.isLoading}
            jobResult={props.jobResult}
            hitNum={toSafeInt(hitNum)}
          />
        }
      ></Route>
      <Route
        path={"genomeview/*"}
        element={
          <BlastResultGenomeView
            job={props.job}
            isLoading={props.isLoading}
            jobResult={props.jobResult}
            hitNum={toSafeInt(hitNum)}
            view={viewId && savedView}
          />
        }
      ></Route>
    </Routes>
  );
};

export { BlastResultHitDetailsView };
